"use client";

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSyncExternalStore } from "react";
import { getActiveProviderPromo } from "../marketing.js";
import { ScxIcon } from "./provider-icons.js";
import { formatCountdown, useCountdown } from "./use-countdown.js";
function subscribe(onChange) {
  var interval = setInterval(onChange, 1000);
  return function () {
    return clearInterval(interval);
  };
}
export function useProviderPromo() {
  return useSyncExternalStore(subscribe, getActiveProviderPromo, _temp);
}
function _temp() {
  return null;
}
export function ProviderPromoContent(_a) {
  var promo = _a.promo,
    trailing = _a.trailing;
  var countdown = useCountdown(promo.endsAt);
  return _jsxs(_Fragment, {
    children: [_jsx(ScxIcon, {
      className: "h-5 w-auto shrink-0",
      "aria-label": "SCX.ai",
      role: "img"
    }), _jsxs("span", {
      className: "text-[13px] font-medium leading-tight",
      children: [_jsxs("span", {
        className: "mr-1 rounded-md bg-neutral-950 px-2 py-1 font-semibold text-white dark:bg-white dark:text-neutral-950",
        children: [promo.discountPercent, "% off"]
      }), " ", promo.modelCount, " SCX models"]
    }), _jsxs("span", {
      className: "inline-flex items-center gap-2.5 whitespace-nowrap",
      children: [_jsxs("span", {
        suppressHydrationWarning: true,
        className: "rounded-full bg-black/10 px-2 py-0.5 font-mono text-[11px] font-semibold tabular-nums leading-tight dark:bg-white/10",
        children: ["ends in ", formatCountdown(countdown)]
      }), _jsx("span", {
        className: "hidden text-xs font-medium lg:inline",
        children: "View offer"
      }), trailing]
    })]
  });
}